import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-comparison-cards', 'compareDetails', 'Compare details');
Labels.set('ui-comparison-cards', 'available', 'Available');
Labels.set('ui-comparison-cards', 'notAvailable', 'Not available');
Labels.set('ui-comparison-cards', 'comparisonItem1', 'Comparison item 1');
Labels.set('ui-comparison-cards', 'comparisonItem2', 'Comparison item 2');
Labels.set(
    'ui-comparison-cards',
    'selectProductsCompare',
    'Select which products to compare.'
);
